/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddUser
 */
export interface AddUser {
  /**
   *
   */
  readonly userId?: number;
  /**
   *
   */
  username: string;
  /**
   *
   */
  firstName?: string;
  /**
   *
   */
  lastName?: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  externalUserId: string;
}

/**
 * Check if a given object implements the AddUser interface.
 */
export function instanceOfAddUser(value: object): value is AddUser {
  if (!("username" in value) || value["username"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (
    (!("externalUserId" in (value as Record<string, any>)) &&
      !("external_user_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["externalUserId"] === undefined &&
      (value as Record<string, any>)["external_user_id"] === undefined)
  )
    return false;
  return true;
}

export function AddUserFromJSON(json: any): AddUser {
  return AddUserFromJSONTyped(json, false);
}

export function AddUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUser {
  if (json == null) {
    return json;
  }
  return {
    userId: json["user_id"] == null ? undefined : json["user_id"],
    username: json["username"],
    firstName: json["first_name"] == null ? undefined : json["first_name"],
    lastName: json["last_name"] == null ? undefined : json["last_name"],
    email: json["email"],
    externalUserId: json["external_user_id"],
  };
}

export function AddUserToJSON(json: any): AddUser {
  return AddUserToJSONTyped(json, false);
}

export function AddUserToJSONTyped(
  value?: Omit<AddUser, "userId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    username: value["username"],
    first_name: value["firstName"],
    last_name: value["lastName"],
    email: value["email"],
    external_user_id: value["externalUserId"],
  };
}
